'use client';

import {useEffect} from 'react';
import {initAmplitude} from '@/libs/amplitude';

export const AmplitudeInitializer = () => {
  useEffect(() => {
    initAmplitude();
  }, []);

  return null;
};
